import axios from 'axios'

export default {
    getSetting(key){
        return axios.get('/settings/' + key)
            .then(response => {
                return response.data
            })
    },    
    saveSetting(formdata){
        return axios.post('/settings', formdata)
            .then(response => {
                return response.data
            })
    },
   
}